exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2kg5FZIidQSu3l{background:#dfe1e6;border-radius:3px;padding:2px 4px}._2kg5FZIidQSu3l:hover{background:#c1c7d0}._308_lQn_gYpdWx{height:14px;margin-right:3px;vertical-align:middle;width:14px}", ""]);

// exports
exports.locals = {
	"knownServiceLink": "_2kg5FZIidQSu3l",
	"knownServiceIcon": "_308_lQn_gYpdWx"
};